import Icon1c from 'reactApp/components/icons/1capp';
import IconPasswordInput from 'reactApp/components/icons/passwordInputIcon';
import IconUser from 'reactApp/components/icons/user';
import IconArrowRevert from 'reactComponents/icons/arrowRevert';
import IconCheckmarkRound from 'reactComponents/icons/checkMarkRound';
import IconCoins from 'reactComponents/icons/coins';
import IconControls from 'reactComponents/icons/controls';
import IconCreateSnapshot from 'reactComponents/icons/createSnapshot';
import IconCreditCard from 'reactComponents/icons/creditCard';
import IconDisk from 'reactComponents/icons/disk';
import IconDone from 'reactComponents/icons/done';
import IconEdit from 'reactComponents/icons/edit';
import IconEject from 'reactComponents/icons/eject';
import IconEmptyList from 'reactComponents/icons/emptyList';
import IconFile from 'reactComponents/icons/file';
import IconAdmin from 'reactComponents/icons/IconAdmin';
import { IconBackupUse } from 'reactComponents/icons/IconBackupUse';
import IconMcs from 'reactComponents/icons/IconMcs';
import IconMonitoring from 'reactComponents/icons/IconMonitoring';
import IconSpecialServices from 'reactComponents/icons/IconSpecialServices';
import IconSupport from 'reactComponents/icons/IconSupport';
import IconUsers from 'reactComponents/icons/IconUsers';
import { IconWarning } from 'reactComponents/icons/IconWarning';
import IconInfo from 'reactComponents/icons/info';
import IconLock from 'reactComponents/icons/lock';
import IconPhone from 'reactComponents/icons/phone';
import IconPlay from 'reactComponents/icons/play';
import { IconPlus } from 'reactComponents/icons/plus';
import IconReload from 'reactComponents/icons/reload';
import IconRoute from 'reactComponents/icons/route';
import IconSearch from 'reactComponents/icons/search';
import IconAnalyticDatabases from 'reactComponents/icons/services/IconAnalyticDatabases';
import IconBigdata from 'reactComponents/icons/services/IconBigdata';
import IconContainers from 'reactComponents/icons/services/IconContainers';
import IconDatabases from 'reactComponents/icons/services/IconDatabases';
import IconGpu from 'reactComponents/icons/services/IconGpu';
import IconInfra from 'reactComponents/icons/services/IconInfra';
import IconMachineLearning from 'reactComponents/icons/services/IconMachineLearning';
import IconMarketplace from 'reactComponents/icons/services/IconMarketplace';
import IconRouble from 'reactComponents/icons/services/IconRouble';
import IconStorage from 'reactComponents/icons/services/IconStorage';
import IconSettings from 'reactComponents/icons/settings';
import IconStop from 'reactComponents/icons/stop';
import IconTelegram from 'reactComponents/icons/telegram';
import IconTrash from 'reactComponents/icons/trash';
import UploadFile from 'reactComponents/icons/uploadFile';
import IconWindow from 'reactComponents/icons/window';

const NAME_TO_CLASS = {
    plus: IconPlus,
    edit: IconEdit,
    trash: IconTrash,
    play: IconPlay,
    start: IconPlay,
    stop: IconStop,
    route: IconRoute,
    reboot: IconArrowRevert,
    backup: IconBackupUse,
    password: IconPasswordInput,
    user: IconUser,
    users: IconUsers,
    admin: IconAdmin,
    locked: IconLock,
    info: IconInfo,
    coins: IconCoins,
    creditCard: IconCreditCard,
    settings: IconSettings,
    controls: IconControls,
    phone: IconPhone,
    disk: IconDisk,
    createSnapshot: IconCreateSnapshot,
    eject: IconEject,
    telegram: IconTelegram,
    file: IconFile,
    done: IconDone,
    infra: IconInfra,
    containers: IconContainers,
    storage: IconStorage,
    marketplace: IconMarketplace,
    gpu: IconGpu,
    databases: IconDatabases,
    analyticDatabases: IconAnalyticDatabases,
    rouble: IconRouble,
    bigdata: IconBigdata,
    machineLearning: IconMachineLearning,
    '1capp': Icon1c,
    warning: IconWarning,
    support: IconSupport,
    uploadFile: UploadFile,
    emptyList: IconEmptyList,
    specialServices: IconSpecialServices,
    main: IconMcs,
    window: IconWindow,
    reload: IconReload,
    search: IconSearch,
    checkmarkRound: IconCheckmarkRound,
    monitoring: IconMonitoring,
    none: null,
};

export type IconName = keyof typeof NAME_TO_CLASS;

export const IconUtils = {
    handleNameOrClass: (icon) => {
        return typeof icon === 'string' ? NAME_TO_CLASS[icon] : icon;
    },
};

export type IconProps = {
    width?: string | number;
    height?: string | number;
    className?: string;
    size?: string | number;
};
